export default "__VITE_ASSET__BeiFqKbi__"